import { ParamMap } from '@angular/router';
import { IAWSConfig, IEnvironment, IFederatedSignInConfig, IOAuthConfig, RuntimeMode } from './environment.type';

export const environment: IEnvironment = {
  name: 'stage',
  runtime: RuntimeMode.PRODUCTION,
  amilearnDashboardUrl: 'https://meetami.sandbox.myabsorb.ca',
  apiBaseUrl: 'https://api.stage.amilearn.ca',
  includeGTMTag: true,
  gtmId: 'GTM-N89X3FV',
  sentryDsn:
    'https://c466a0c9cb3e48db86a56a94b8c07371@o4505308180250624.ingest.sentry.io/4505398736453632',
  subscriptionPaymentLink: 'https://payments.meetami.ca/b/test_9AQ2bz89jbj8acg004',
};

export const awsconfig: IAWSConfig = {
  aws_project_region: 'ca-central-1',
  aws_content_delivery_bucket: 'amilearn-portal-presentation-stage',
  aws_content_delivery_bucket_region: 'ca-central-1',
  aws_content_delivery_url: 'https://portal.stage.amilearn.ca',
  oauth: {},
  Auth: {
    identityPoolId: 'ca-central-1:fe8ba4a5-e17a-4771-8d27-ff6f124a7e1d', // UPDATED
    region: 'ca-central-1',
    identityPoolRegion: 'ca-central-1',
    userPoolId: 'ca-central-1_WPyStyiOc', // UPDATED
    userPoolWebClientId: '3eedbstudq6idlg6lp543020jn', // UPDATED

    mandatorySignIn: false,
    oauth: {},
    refreshHandlers: {},
  },
};

export const federatedSignInConfig: IFederatedSignInConfig = {
  provider: 'cognito-idp.ca-central-1.amazonaws.com/ca-central-1_WPyStyiOc', // UPDATED
  expiresIn: 300,
};

export const oAuthConfig: IOAuthConfig = {
  domain: 'https://amilearn-stage.auth.ca-central-1.amazoncognito.com',
  redirectURI: 'https://portal.stage.amilearn.ca',
  logoutURI: 'https://portal.stage.amilearn.ca/logout',
  grantType: 'authorization_code',
  identityProvider: 'amiconnect-saml-stage',
};

export const openProtectedRoutes = (queryParams: ParamMap) => {
  return false;
};
